module.exports = __webpack_public_path__ + "img/3.6ee85d70.jpg";